import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { IOnboardingStatus } from '@core/models/onboarding.model';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { SetOnboardingStatus } from '@core/state/onboarding/onboarding.actions';
import { Store } from '@ngrx/store';
import { OnboardingService } from 'src/app/components/onboarding/onboarding.service';

export const onboardGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);
  const onboardingService = inject(OnboardingService);
  const store = inject(Store);

  const isAuthenticated = await authenticationService.isAuthenticated();
  if (!isAuthenticated) {
    router.navigateByUrl('/login');
    return false;
  }
  const onboardingStatus =
    await onboardingService.getOnboardingStatus<IOnboardingStatus>();

  if (onboardingStatus) {
    store.dispatch(
      SetOnboardingStatus({
        status: onboardingStatus.registeredStatus,
        onboardingStep: onboardingStatus.onBoardingStep,
      })
    );
    if (onboardingStatus.registeredStatus) {
      router.navigateByUrl('/shipping/ship');
      return false;
    }
  }
  return true;
};
